import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideAppInitializer,
  inject,
  isDevMode,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideNgxMask } from 'ngx-mask';

import { routes } from './app.routes';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { AuthService } from './core/services/auth.service';
import { LanguageService } from './core/services/language.service';
import { TranslocoHttpLoader } from './transloco-loader';
import { provideTransloco } from '@jsverse/transloco';

/**
 * Função de inicialização da autenticação.
 * Garante que o estado de autenticação seja carregado antes da inicialização da aplicação.
 */
export function initializeAuth() {
  const authService = inject(AuthService);
  return authService.initialize();
}
export function initializeLanguage() {
  const languageService = inject(LanguageService);
  return languageService.initialize();
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideClientHydration(withEventReplay()),
    provideHttpClient(withFetch(), withInterceptors([authInterceptor])),
    provideNgxMask(),
    provideAppInitializer(initializeAuth),
    provideAppInitializer(initializeLanguage),
    provideTransloco({
      config: {
        availableLangs: ['en-US', 'es', 'pt-BR'],
        defaultLang: 'en-US',
        fallbackLang: 'pt-BR',
        reRenderOnLangChange: true,
        missingHandler: {
          useFallbackTranslation: true,
        },
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader,
    }),
  ],
};
